import servicesUtils from "../../../utils/servicesUtils";

/** Per-notification-type unread counts inside a bucket (from unread-count API). */

var getUnreadNotificationsCount = function getUnreadNotificationsCount() {
  return servicesUtils.getService("/notifications/unread-count/");
};
export default getUnreadNotificationsCount;